import Permission from "permissions/permission";
import { LegalEntityAccess } from "permissions/resources/legal-entities/legal-entities-permissions-resources";
import { LegalEntityAccessType } from "permissions/resources/legal-entities/legal-entity-access-types";
import { AccessLevel, Scope } from "permissions/resources/permission-resource-types";

export type LegalEntityAdministrationAccess = {
  canViewMembers: boolean;
  canViewInvitations: boolean;
  canInviteMembers: boolean;
  canCancelMemberInvitations: boolean;
  canManageMemberAccess: boolean;
};

export function deriveLegalEntityAdministrationAccess(
  permissions: ReadonlyArray<Permission>,
): LegalEntityAdministrationAccess {
  const hasAccess = (accessType: LegalEntityAccessType, minimumAccessLevel: AccessLevel): boolean =>
    permissions.some((permission) => {
      if (permission.isDisabled || !(permission.resource instanceof LegalEntityAccess)) return false;

      return (
        permission.resource.accessType === accessType &&
        permission.resource.scope >= Scope["Entity-Wide"] &&
        permission.resource.accessLevel >= minimumAccessLevel
      );
    });

  const canWriteMemberInvitations = hasAccess(
    LegalEntityAccessType["Member Invitations"],
    AccessLevel["Read/Write"],
  );

  return {
    canViewMembers: hasAccess(LegalEntityAccessType["Member Information"], AccessLevel["Read-Only"]),
    canViewInvitations: hasAccess(LegalEntityAccessType["Member Invitations"], AccessLevel["Read-Only"]),
    canInviteMembers: canWriteMemberInvitations,
    canCancelMemberInvitations: canWriteMemberInvitations,
    canManageMemberAccess: hasAccess(LegalEntityAccessType["Member Permissions"], AccessLevel["Read/Write"]),
  };
}
